document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector("[data-quick-view-modal]");
  if (!modal) return;

  const closeButton = modal.querySelector("[data-quick-view-close]");
  const image = modal.querySelector("[data-quick-view-image]");
  const title = modal.querySelector("[data-quick-view-title]");
  const price = modal.querySelector("[data-quick-view-price]");
  const comparePrice = modal.querySelector("[data-quick-view-compare-price]");
  const link = modal.querySelector("[data-quick-view-link]");

  const close = () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("rudra-quick-view-open");
  };

  const open = (button) => {
    const imageUrl = button.dataset.productImage;

    if (image && imageUrl) {
      image.src = imageUrl;
      image.alt = button.dataset.productTitle || "";
      image.hidden = false;
    } else if (image) {
      image.hidden = true;
    }

    if (title) title.textContent = button.dataset.productTitle || "";
    if (price) price.textContent = button.dataset.productPrice || "";

    if (comparePrice) {
      comparePrice.textContent = button.dataset.productComparePrice || "";
      comparePrice.hidden = !button.dataset.productComparePrice;
    }

    if (link) link.href = button.dataset.productUrl || "#";

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("rudra-quick-view-open");

    if (closeButton) {
      closeButton.focus();
    }
  };

  document.querySelectorAll("[data-quick-view]").forEach((button) => {
    button.addEventListener("click", () => {
      open(button);
    });
  });

  if (closeButton) {
    closeButton.addEventListener("click", close);
  }

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      close();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      close();
    }
  });
});
